import { AtpAgent } from "@atproto/api";

const agent = new AtpAgent({
  service: "https://public.api.bsky.app",
});

export default agent;
